import spinRoute from './spinRoute';

import jump from '../views/home/jump';
import labelRoutes from '../views/_label/routes';
import kygMsg from '../js/kygMsg';
import survey from '../views/survey/routes';
import addressBookRoutes from '../views/addressbook/routes'
import employeeCareRoutes from '../views/employeeCare/routes'
import flow from '../views/flow/routes';
import okr from '../pages/okr/routes';
//对应home内页面
const homeRoutes = () => [
    {
        path: '/',
        component: () => spinRoute.require(import('../views/home/home.vue')),
        meta: { title: kygMsg(120048, '首页'), keepAlive: true, noGoBack: true }
    },
    {
        path: '/jump',
        component: jump,
    },
    {
        path: '/msgs',
        component: () => spinRoute.require(import('../views/portal/msg/pages/news.vue')),
        meta: { title: kygMsg(321726, '我的消息') }
    },
    {
        path: '/vue',
        component: () => spinRoute.require(import('../views/dynamicPage/vuePage.js')),
    },
    {
        path: '/msglist',
        component: () => spinRoute.require(import('../views/portal/msg/msgList.vue')),
        meta: { title: kygMsg(111605, '我的提醒') },
        children: [
            {
                path: '/msg/news',
                component: () => spinRoute.require(import('../views/portal/msg/pages/news.vue')),
                meta: { title: kygMsg(321726, '我的消息') }
            },
            {
                path: '/msg/approveMenu',
                component: () => spinRoute.require(import('../views/flow/menu/approveMenu.vue')),
                meta: { title: kygMsg(321727, '我的审批') },
            },
            {
                path: '/msg/noticeList',
                component: () => spinRoute.require(import('../views/portal/msg/pages/msgNoticeList.vue')),
                meta: { title: kygMsg(902055, '告知记录'), },
            },
            {
                path: '/msg/taskList',
                component: () => spinRoute.require(import('../views/portal/msg/pages/msgTaskList.vue')),
                meta: { title: kygMsg(900583, '待批流程') },
            },
            {
                path: '/msg/historyList',
                component: () => spinRoute.require(import('../views/portal/msg/pages/msgHistoryList.vue')),
                meta: { title: kygMsg(321728, '审批历史'), }
            },
        ]
    },
    {
        path: '/myapp',
        redirect: '/allApp',
        component: () => spinRoute.require(import('../views/portal/apps/myapp.vue')),
        meta: { title: kygMsg(321729, '我的应用') },
        children: [
            {
                path: '/allApp',
                component: () => spinRoute.require(import('../views/portal/apps/pages/allApp.vue')),
                meta: { title: kygMsg(311554, '所有') }
            },
            {
                path: '/myfavApp',
                component: () => spinRoute.require(import('../views/portal/apps/pages/myfavApp.vue')),
                meta: { title: kygMsg(321730, '我的收藏') }
            },
        ]
    },
    {
        path: '/arrangeWork',
        component: () => spinRoute.require(import('../views/arrange/arrangeWork.vue')),
        meta: {
            title: kygMsg(321757, '排班管理'),
            hideBarHead: true,
            hideBarFoot: true,
            setFullScreen: true
        },
    },
    ...survey(),
    ...flow(),
    ...employeeCareRoutes(),
    ...okr(),
];

const flowRoutes = () => [
    {
        path: '/flow',
        redirect: '/flow/initiateMenu',
        component: () => spinRoute.require(import('../views/flow/tab/flowTab.vue')),
        meta: { title: kygMsg(321731, '我的申请') },
        children: [
            {
                path: '/flow/initiateMenu',
                component: () => spinRoute.require(import('../views/flow/menu/initiateMenu.vue')),
                meta: { title: kygMsg(900482, '发起申请'), showFav: true, noGoBack: true }
            },
            {
                path: '/flow/favMenu',
                component: () => spinRoute.require(import('../views/flow/menu/favMenu.vue')),
                meta: { title: kygMsg(321730, '我的收藏') }
            },
            {
                path: '/flow/mineList',
                component: () => spinRoute.require(import('../views/flow/list/mineList.vue')),
                meta: { title: kygMsg(321732, '最近申请') }
            },
            //替换我的申请
            {
                path: '/flow/mineMenu',
                component: () => spinRoute.require(import('../views/flow/menu/mineMenu.vue')),
                meta: { title: kygMsg(902069, '申请记录') },
            },
            {
                path: '/flow/mineList',
                component: () => spinRoute.require(import('../views/flow/list/mineList.vue')),
                meta: { title: kygMsg(902069, '申请记录') },
            },
            //替换收藏
            {
                path: '/flow/approveMenu',
                component: () => spinRoute.require(import('../views/flow/menu/approveMenu.vue')),
                meta: { title: kygMsg(321727, '我的审批') },
            },
            {
                path: '/flow/taskList',
                component: () => spinRoute.require(import('../views/flow/list/taskList.vue')),
                meta: { title: kygMsg(900583, '待批流程') },
            },
            {
                path: '/flow/historyList',
                component: () => spinRoute.require(import('../views/flow/list/historyList.vue')),
                meta: { title: kygMsg(321728, '审批历史') },
            },
            {
                path: '/flow/noticeList',
                component: () => spinRoute.require(import('../views/flow/list/noticeList.vue')),
                meta: { title: kygMsg(902055, '告知记录') },
            },
        ]
    },
    {
        path: '/wfApproveMenu',
        component: () => spinRoute.require(import('../views/flow/menu/approveMenu.vue')),
        meta: { title: kygMsg(321727, '我的审批'), noGoBack: true },
    },
    {
        path: '/wfTaskList',
        component: () => spinRoute.require(import('../views/flow/list/taskList.vue')),
        meta: { title: kygMsg(900583, '待批流程') },
    },
    {
        path: '/wfHistoryList',
        component: () => spinRoute.require(import('../views/flow/list/historyList.vue')),
        meta: { title: kygMsg(321728, '审批历史') },
    },
    {
        path: '/wfNoticeList',
        component: () => spinRoute.require(import('../views/flow/list/noticeList.vue')),
        meta: { title: kygMsg(902055, '告知记录') },
    },
    {
        path: '/wfInitiateMenu',
        component: () => spinRoute.require(import('../views/flow/menu/initiateMenu.vue')),
        meta: { title: kygMsg(900482, '发起申请') },
    },
    {
        path: '/wfMineMenu',
        component: () => spinRoute.require(import('../views/flow/menu/mineMenu.vue')),
        meta: { title: kygMsg(902069, '申请记录') },
    },
    {
        path: '/wfMineList',
        component: () => spinRoute.require(import('../views/flow/list/mineList.vue')),
        meta: { title: kygMsg(902069, '申请记录') },
    },
]

const tabs = () => ({
    '/': homeRoutes(),
    '/team': [{
        path: '/team',
        component: () => spinRoute.require(import('../views/portal/team/team.vue')),
        meta: { title: kygMsg(120844, '我的团队'), noGoBack: true }
    }],
    '/flow': flowRoutes(),
    '/time': [{
        path: '/time',
        component: () => spinRoute.require(import('../views/portal/time/time.vue')),
        meta: { title: kygMsg(321733, '时间'), noGoBack: true }
    }],
    '/mine': [{
        path: '/mine',
        component: () => spinRoute.require(import('../views/portal/mine/mine.vue')),
        meta: { title: kygMsg(320707, '我的设置'), noGoBack: true }
    }],
    '/label/queryContainer': labelRoutes(),
    '/addressbook/addressbook': addressBookRoutes(),
    '/biportal': [{
        path: '/biportal',
        component: () => spinRoute.require(import('../views/portal/windows/biportal.vue')),
        meta: { title: 'BI Portal', hideBarHead: true }
    }],
})

//对应下方tabs的页面。返回函数延迟调用，以加载多语言
export default tabs;

